import { render, staticRenderFns } from "./tenant-renew.vue?vue&type=template&id=22503921"
import script from "./tenant-renew.vue?vue&type=script&lang=js"
export * from "./tenant-renew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports